import React, { useState, useEffect } from 'react'
import Box from "@mui/material/Box";
import { getUserById } from "../../services/userService";
import Typography from "@mui/material/Typography";  
// import iconsgoogle from "../../assets/images/iconsgoogle.png";
// import iconslinkedin from "../../assets/images/iconslinkedin.png";  
import { Button } from '@mui/material';
import { grey } from '@mui/material/colors';

const ProfileDetails = () => {
    const [user, setUser] = useState(null);

    const [firstName, setFirstName] = useState(user?.firstName || "");
    const [lastName, setLastName] = useState(user?.lastName || "");
    const [emailId, setEmailId] = useState(user?.email || "");
    const [phone, setPhone] = useState(user?.phone || "");
    const [designation, setDesignation] = useState(user?.designation || "");
    const [organization, setOrganization] = useState(user?.company || "");
    const [profilePicture, setProfilePicture] = useState(user?.profilePicture || "");
    const userInfo = localStorage.getItem("userInfo");
    useEffect(() => {
      const fetchUser = async () => {
    if (userInfo) {
        try {
            const parsed = JSON.parse(userInfo);
            const userData = await getUserById(parsed._id);
            setUser(userData);
            setFirstName(userData.firstName);
            setLastName(userData.lastName);
            setEmailId(userData.email);
            setPhone(userData.phone);
            setDesignation(userData.designation);
            setOrganization(userData.company);
            setProfilePicture(userData.profilePicture);
        } catch {
            console.log("Error fetching user");
        }
    }
    };
    fetchUser();
  }, []);

    return (
        <Box sx={{ flex: 1, display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-start', flexDirection: 'column', m:2 }}>

            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', backgroundColor: '#0a1128', borderRadius: 1, boxShadow: 2, p: 2  , mb:-2, width: '100%' }}>
                <Typography variant="h5" sx={{ fontWeight: 600, color: '#eff7f6', mb: 2 }}>Profile Details</Typography>
            </Box>
                
            <Box
                sx={{
                    maxWidth: '100%',
                    minWidth: '100%',
                    bgcolor: "#fff",
                    borderRadius: 1,
                    boxShadow: 2,
                    p: 4,
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "flex-start",
                    gap: 5,
                }}
            >  
            
                {/* Profile Image on the right */}
                <Box sx={{ m: 4, maxWidth: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
                    <img src={profilePicture} alt="Profile" style={{ width: 150, height: 150, borderRadius: "50%", border: "3px solid #1BE885" }} />
                    {/* Social Icons */}
                    {/* <Box sx={{ display: 'flex', gap: 3, mt: 2, justifyContent: 'center', mb: 2 }}>
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <Box
                                sx={{
                                    bgcolor: '#e0e0e0',
                                    borderRadius: '8px',
                                    width: 56,
                                    height: 56,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    boxShadow: user?.googleProfile ? 2 : 0,
                                    cursor: 'pointer',
                                }}
                                title={user?.googleProfile ? 'Google Connected' : 'Google Not Connected'}
                            >
                                <img src={iconsgoogle} alt="Google" style={{ width: 36, height: 36, borderRadius: 4, filter: user?.googleProfile ? 'none' : 'grayscale(100%)' }} />
                            </Box>
                            {user?.googleProfile && ( <Box sx={{ mt: 1, fontSize: 12, color: '#1BE885', fontWeight: 600 }}>Connected</Box> )} 
                        </Box>
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <Box
                                sx={{
                                    bgcolor: user?.linkedinId ? '#1BE885' : '#e0e0e0',
                                    borderRadius: '8px',
                                    width: 56,
                                    height: 56,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    boxShadow: user?.linkedinId ? 2 : 0,
                                    border: user?.linkedinId ? '2px solid #1BE885' : '2px solid #e0e0e0',
                                    cursor: 'pointer',
                                }}
                                title={user?.linkedinId ? 'LinkedIn Connected' : 'LinkedIn Not Connected'}
                            >
                                <img src={iconslinkedin} alt="LinkedIn" style={{ width: 36, height: 36, borderRadius: 4, filter: user?.linkedinId ? 'none' : 'grayscale(100%)' }} />
                            </Box>
                            {user?.linkedinId && (<Box sx={{ mt: 1, fontSize: 12, color: '#1BE885', fontWeight: 600 }}>Connected</Box>)} 
                        </Box> 
                    </Box> */}
                    {/* Social Icons Ends */}
                </Box>

                {/* Text fields on the left */}
                <Box component="form" sx={{ width: "100%", display: "flex", flexDirection: "column", gap: 2 }}>
                    <Box sx={{ display: "flex", gap: 2 }}>
                        <Box sx={{ flex: 1 }}>
                            <label htmlFor="firstName" style={{ fontWeight: 600 }}>First Name</label>
                            <input id="firstName" name="firstName" type="text" value={firstName} style={{width: "100%", padding: 8, borderRadius: 4, border: "1px solid #ccc"}} onChange={(e) => setFirstName(e.target.value)} />
                        </Box>
                        <Box sx={{ flex: 1 }}>
                            <label htmlFor="lastName" style={{ fontWeight: 600 }}>Last Name</label>
                            <input id="lastName" name="lastName" type="text" value={lastName} style={{ width: "100%", padding: 8, borderRadius: 4, border: "1px solid #ccc"}} onChange={(e) => setLastName(e.target.value)} />
                        </Box>
                    </Box>
                    <Box sx={{ display: "flex", gap: 2 }}>
                        <Box sx={{ flex: 1 }}>
                            <label htmlFor="email" style={{ fontWeight: 600 }}>Email</label>
                            <input id="email" name="email" type="email" value={emailId} style={{width: "100%", padding: 8, borderRadius: 4, border: "1px solid #ccc"}} readOnly />
                            <label htmlFor="Phone" style={{ fontWeight: 600 }}>Phone</label>
                            <input id="phone" name="phone" type="phone" value={phone} style={{width: "100%", padding: 8, borderRadius: 4, border: "1px solid #ccc"}} onChange={(e) => setPhone(e.target.value)} />
                        </Box>
                    </Box>
                    <Box>
                        <label htmlFor="designation" style={{ fontWeight: 600 }}>Designation</label>
                        <input
                            id="designation"
                            name="designation"
                            type="text"
                            value={designation}
                            style={{ width: "100%", padding: 8, borderRadius: 4, border: "1px solid #ccc" }}
                            onChange={(e) => setDesignation(e.target.value)}
                        />
                    </Box> 
                    <Box>
                        <label htmlFor="organization" style={{ fontWeight: 600 }}>Organization</label>
                        <input
                            id="organization"
                            name="organization"
                            type="text"
                            value={organization}
                            style={{ width: "100%", padding: 8, borderRadius: 4, border: "1px solid #ccc" }}
                            onChange={(e) => setOrganization(e.target.value)}
                        />
                    </Box>
                    <Button type="submit" style={{ marginTop: 16, background: "#1BE885", color: "#212121", fontWeight: 700, border: 0, borderRadius: 4, padding: "10px 0", fontSize: 16, cursor: "pointer" }}>Update Profile</Button>
                </Box> 
            </Box>
        </Box>
  )
}

export default ProfileDetails
